<template>
  <v-card class="mt-4">
    <v-card-title>
      {{ name }}
      <v-spacer />
      <v-icon color="error" v-if="!isValid">warning</v-icon>
    </v-card-title>
    <v-card-text>
      <v-form ref="mentorshipFeedbackFormEdit">
        <v-card
          v-for="(content, contentIndex) in contents"
          :key="contentIndex"
          class="mb-4"
        >
          <v-card-subtitle>
            <v-row no-gutters align="center">
              <span>
                {{ contentIndex + 1 }}.
                {{
                  $t(
                    `management.mentorship.feedback.edit.element.${content.fieldType}`
                  )
                }}
              </span>

              <v-spacer />

              <v-btn icon @click="deleteElement(contentIndex)"
                ><v-icon>delete_forever</v-icon>
              </v-btn>
              <add-element-menu
                :addableElements="addableElements"
                @addElement="(item) => addElement(item, contents, contentIndex)"
              />
            </v-row>
          </v-card-subtitle>
          <v-divider />
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <span
                  :class="
                    content.fieldType == 'textBold' ? 'font-weight-bold' : ''
                  "
                >
                  {{
                    content.labelLocales &&
                    content.labelLocales.length &&
                    content.labelLocales[0].value.length
                      ? content.labelLocales[0].value
                      : "Lorem ipsum dolor sit amet"
                  }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-if="content.fieldType == 'textarea'"
                  disabled
                  hide-details
                  class="pa-0 my-0"
                />

                <span v-else-if="content.fieldType == 'text'" />
                <span v-else-if="content.fieldType == 'textBold'" />

                <template v-else-if="content.fieldType == 'checkbox'">
                  <v-row no-gutters class="ml-2">
                    <v-col>
                      <v-checkbox
                        disabled
                        hide-details
                        style="margin-top: 0px !important"
                        :label="$t('dialog.yes')"
                      />
                    </v-col>
                    <v-col>
                      <v-checkbox
                        disabled
                        hide-details
                        style="margin-top: 0px !important"
                        :label="$t('dialog.no')"
                      />
                    </v-col>
                  </v-row>
                </template>

                <v-rating
                  v-else-if="content.fieldType == 'rating'"
                  :min="content.min"
                  :max="content.max"
                  class="pa-0"
                  readonly
                ></v-rating>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions :key="`mentor${contentIndex}`" class="ma-2">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-for="(locale, index) in content.labelLocales"
                  :key="`${contentIndex}_labelLocales${index}`"
                  :label="$t('management.mentorship.feedback.edit.label')"
                  v-model="locale.value"
                  hide-details="auto"
                  :rules="[rules.required]"
                >
                  <template v-slot:prepend>
                    {{ locale.language.toUpperCase() }}
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <add-element-menu
        :addableElements="addableElements"
        @addElement="(item) => addElement(item, contents)"
      />
      <v-spacer></v-spacer>
      <v-btn text color="grey darken-1" class="ma-2" @click="hide">
        {{ $t("dialog.cancel") }}
      </v-btn>
      <v-btn color="primary" class="ma-2" @click="save()">
        {{ $t("dialog.save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { appendNewLocale } from "@/utils/mentorshipFeedback.js";

import AddElementMenu from "@/components/management/component/AddMentorshipFeedbackElementMenu";

export default {
  props: {
    formContents: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    locales: {
      type: Array,
      required: true,
    },
  },
  components: {
    AddElementMenu,
  },
  data() {
    return {
      isValid: true,
      addableElements: ["rating", "textarea", "text", "textBold", "checkbox"],
      rules: {
        required: (value) => !!value || this.$t("validation.required"),
      },
    };
  },
  watch: {
    locales(newVal) {
      this.isValid = false;
      this.$emit("isValid", this.isValid);

      appendNewLocale(this.contents, newVal);
    },
  },
  computed: {
    contents() {
      return this.formContents;
    },
  },
  methods: {
    deleteElement(index) {
      this.contents.splice(index, 1);
    },
    addElement(element, contents, index) {
      const newElement = this.getElement(element);
      if (index) {
        contents.splice(index, 0, newElement);
      } else {
        contents.push(newElement);
      }
    },
    getElement(element) {
      const labelLocales = this.locales.map((locale) => ({
        language: locale,
        value: "",
      }));

      switch (element) {
        case "rating":
          return {
            fieldType: "rating",
            labelLocales,
            min: 1,
            max: 5,
            value: null,
          };

        case "textarea":
          return {
            fieldType: "textarea",
            labelLocales,
            value: null,
          };
        case "text":
          return {
            fieldType: "text",
            labelLocales,
            value: null,
          };
        case "textBold":
          return {
            fieldType: "textBold",
            labelLocales,
            value: null,
          };
        case "checkbox":
          return {
            fieldType: "checkbox",
            labelLocales,
            value: null,
          };
      }
    },
    save() {
      if (!this.$refs.mentorshipFeedbackFormEdit.validate()) {
        return;
      }
      this.isValid = true;
      if (this.contents.length === 0) {
        this.isValid = false;
        return;
      }
      this.$emit("isValid", this.isValid);
      this.$emit("save", this.contents);
    },
    hide() {
      this.$emit("hide");
    },
  },
};
</script>
